import { i18n } from '../data'

export default ({ debug, store }) => {
  return new Promise((resolve) => {
    debug && console.log('bootstrap.i18n', 'init');
    
    const i = new i18n();
    i.init();

    store.dispatch('bootstrap/i18n', i);

    debug && console.log('bootstrap.i18n', 'completed');

    return resolve({ VueI18N: i });
  })
}
